import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
/**
 * Slider
 */
const TemplateCarouselSlider = ({ boxStyle, slideBoxSet, contentSet, contentCount, backIcon, nextIcon }) => {
  
  const [visibleSlides, setVisibleSlides] = useState(1);
  const messageBoxDef = useRef(0);
  // const slideBoxSize = slideBoxSet.width;
  const slideBoxSize = slideBoxSet.width + slideBoxSet.margin * 2;
  
  /*
  // 퀵버튼 캐러셀 width 구하기
  let slideBoxWidth = 0;
  if(backIcon === '_back_quick_btn') {
    for(const item of contentSet().props.children.props.children){
      if(item.props.children.props.children.ref.current.clientWidth !== undefined){
        // console.log(item.props.children.props.children.ref.current.clientWidth)
        slideBoxWidth += item.props.children.props.children.ref.current.clientWidth;
      }
    }
  }
  if(slideBoxWidth > 0) {
    slideBoxSize = slideBoxWidth / contentCount + slideBoxSet.margin * 2;
  } 

  console.log('== TemplateCarouselSlider slideBoxSet' ,slideBoxSet);
  */

  useLayoutEffect(() => {
    let clientWidth = messageBoxDef.current.clientWidth;
    setVisibleSlides(clientWidth / slideBoxSize);
    function handleResize(a) {
      // console.log(backIcon, ' :: ', clientWidth ,'/', slideBoxSize);
      // console.log(backIcon , '  clientWidth / slideBoxSize : ' ,clientWidth / slideBoxSize);
      clientWidth = messageBoxDef.current.clientWidth;
      setVisibleSlides(clientWidth / slideBoxSize);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);                                                                         
  }, []);

  return ( 
    <div className="_carousel_div" ref={messageBoxDef}>
      <CarouselProvider 
        visibleSlides={1} className="_message_temp_carousel_div" totalSlides={contentCount}
        currentSlide={0}
      >
        <Slider role="list">{contentSet()}</Slider>
        <ButtonBack className={backIcon}>
          <i className='ri-arrow-left-circle-fill' />
        </ButtonBack>
        <ButtonNext className={nextIcon}>
          <i className='ri-arrow-right-circle-fill' />
        </ButtonNext>
      </CarouselProvider>
    </div>
  );
};

TemplateCarouselSlider.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet: PropTypes.object,
  contentCount: PropTypes.number,
  contentSet: PropTypes.func,
  backIcon: PropTypes.string,
  nextIcon: PropTypes.string,
};
TemplateCarouselSlider.defaultProps = {
  boxStyle: {},
  slideBoxSet: { width: 300, margin: 9, height: '200px' },
  contentCount: 0,
  contentSet: () => {},
  backIcon: '_back_button',
  nextIcon: '_next_button',
};

export default TemplateCarouselSlider;
